import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form--nested" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-11" };
const _hoisted_4 = { class: "col-1" };
const _hoisted_5 = { class: "form__collection-item-button" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "form__collection-buttons" };
import { computed, ref, watch } from 'vue';
import log from "../../services/Logger";
import Icon from "../Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlForm',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {},
        fieldPrefix: {},
        submitted: { type: Boolean }
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const innerFieldPrefix = computed(() => props.fieldPrefix === undefined || props.fieldPrefix === ''
            ? props.field.name
            : props.fieldPrefix + '.' + props.field.name);
        const fieldOptions = computed(() => props.field.options || {});
        const items = ref(createItems());
        function getData() {
            return fieldOptions.value.collection
                ? items
                : props.data;
        }
        function createItems() {
            return fieldOptions.value.collection ? props.data : [];
        }
        // changes from the outside
        watch(() => props.data, () => items.value = createItems());
        // changes from the inside
        function onChange() {
            const newData = getData();
            log('FieldControlForm@change', props.field.name, newData);
            emit('change', newData);
        }
        function createCollectionItemFieldPrefix(index) {
            return innerFieldPrefix.value + '[' + index + ']';
        }
        function removeCollectionItem(item) {
            if (!fieldOptions.value.collection) {
                return;
            }
            const itemIndex = items.value.indexOf(item);
            items.value.splice(itemIndex, 1);
            // Reset potential validation errors for removed item
            Object.keys(props.validation.fields)
                .filter(validationField => validationField.startsWith(createCollectionItemFieldPrefix(itemIndex)))
                .forEach(validationField => props.validation.fields[validationField] = []);
            onChange();
        }
        function createCollectionItem() {
            if (!fieldOptions.value || !fieldOptions.value.collection) {
                return;
            }
            items.value.push({});
            onChange();
        }
        return (_ctx, _cache) => {
            const _component_form_fields = _resolveComponent("form-fields");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!fieldOptions.value.collection)
                    ? (_openBlock(), _createBlock(_component_form_fields, {
                        key: 0,
                        form: __props.form,
                        fields: __props.field.fields,
                        "field-prefix": innerFieldPrefix.value,
                        data: __props.data,
                        disabled: fieldOptions.value.disabled,
                        validation: __props.validation,
                        submitted: __props.submitted,
                        onChange: onChange
                    }, null, 8, ["form", "fields", "field-prefix", "data", "disabled", "validation", "submitted"]))
                    : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (fieldOptions.value.collection)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "form--nested form--nested-collection"
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        (fieldOptions.value.componentBeforeCollectionItem)
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(fieldOptions.value.componentBeforeCollectionItem), {
                                                key: 0,
                                                item: item,
                                                field: __props.field,
                                                form: __props.form,
                                                validation: __props.validation,
                                                params: fieldOptions.value.params,
                                                submitted: __props.submitted
                                            }, null, 8, ["item", "field", "form", "validation", "params", "submitted"]))
                                            : _createCommentVNode("", true),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _createVNode(_component_form_fields, {
                                            form: __props.form,
                                            fields: __props.field.fields,
                                            "field-prefix": createCollectionItemFieldPrefix(index),
                                            data: item,
                                            disabled: fieldOptions.value.disabled,
                                            validation: __props.validation,
                                            submitted: __props.submitted,
                                            onChange: onChange
                                        }, null, 8, ["form", "fields", "field-prefix", "data", "disabled", "validation", "submitted"]),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        (fieldOptions.value.componentAfterCollectionItem)
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(fieldOptions.value.componentAfterCollectionItem), {
                                                key: 1,
                                                item: item,
                                                field: __props.field,
                                                form: __props.form,
                                                validation: __props.validation,
                                                params: fieldOptions.value.params,
                                                submitted: __props.submitted
                                            }, null, 8, ["item", "field", "form", "validation", "params", "submitted"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            (!fieldOptions.value.disabled && fieldOptions.value.collectionAddRemove !== false)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    onClick: _withModifiers(($event) => (removeCollectionItem(item)), ["prevent"]),
                                                    class: "button button--small",
                                                    href: ""
                                                }, [
                                                    _createVNode(Icon, { name: "trash-alt" })
                                                ], 8, _hoisted_6))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128)),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            (!fieldOptions.value.disabled && fieldOptions.value.collectionAddRemove !== false)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (createCollectionItem()), ["prevent"])),
                                    class: "button button--small",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "plus" })
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
